import { useLocation } from 'react-router-dom';
import Header from './Header';

function HomePage() {
    const location = useLocation();
    const genderCodes = {'M':'Male', 'F':'Female', 'U':'Unspecified', 'NULL': null};
    const { data } = location.state || { data: { FirstName: '', LastName: '' }};

    const dob = data.DateOfBirth ? new Date(data.DateOfBirth) : null;
    const dobYear = dob ? dob.getFullYear().toString() : '';
    const dobMonth = dob ? (dob.getMonth() + 1).toString().padStart(2, '0') : '';
    const dobDay = dob ? dob.getDate().toString().padStart(2, '0') : '';

    const jotFormUrl = `${process.env.REACT_APP_JOTFORM_URL}?EappId=${data.eDocsID}`
                        + `&MemberId=${data.IMSeMemberID}`
                        + `&Name[first]=${data.FirstName ?? ''}&Name[middle]=${data.MiddleName ?? ''}`
                        + `&Name[last]=${data.LastName ?? ''}&Name[suffix]=${data.Suffix ?? ''}`
                        + `&MobilePhone=${data.MobilePhone ?? ''}&HomePhone=${data.HomePhone ?? ''}`
                        + `&Email=${data.EmailAddress ?? ''}`
                        + `&DOB[day]=${dobDay}&DOB[month]=${dobMonth}&DOB[year]=${dobYear}`
                        + `&Gender=${genderCodes[data.Gender ?? 'NULL']}&Marital=${data.MaritalStatus ?? ''}`
                        + `&ssn=${data.SSN ?? ''}&sin=${data.SiN ?? ''}`
                        + `&Trade=${data.PrimaryTrade ?? ''}`
                        + `&DC=${data.DCAbbreviation ?? ''}&LU=${data.LUAbbreviation ?? ''}`
                        + `&Class=${data.MemberType ?? ''}&BU=${data.BargainingUnit ?? ''}`
                        + `&MilitaryStatus=${data.MilitaryStatus ?? ''}&MilitaryBranch=${data.MilitaryBranch ?? ''}`
                        + `&Education=${data.Education ?? ''}&School=${data.SchoolAttended ?? ''}`
                        + `&Citizenship=${data.Citizenship}&Voter=${data.RegisteredVoter ?? ''}`
                        + `&Languages=${data.Language.join(',')}&Ethnicities=${data.Race.join(',')}`
                        + `&Shirt=${data.ShirtSize ?? ''}&HelmetsTo=${data.HelmetsToHardHats ?? ''}`;

    return (
        <div id='content'>
            <Header />
            <div id='instructions'>Hello {data.FirstName} {data.LastName}.  Select the link to get started with your application.</div>

            <a href={jotFormUrl} target='_blank' rel='noreferrer'>
                <div>
                    <img src='static/images/jotform-icon-dark-400x400.png' width='40px' />
                </div>
                <div>Membership<br></br>Application</div>
            </a>

        </div>

    )
}

export default HomePage;
